import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhotoOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18 3.98H5.97c-2.1 0-3.8 1.7-3.8 3.8v8.45c0 2.1 1.7 3.8 3.8 3.8H18c2.1 0 3.8-1.7 3.8-3.8V7.77c0-2.1-1.7-3.8-3.8-3.8v.01ZM5.97 18.42c-1.03 0-1.88-.71-2.13-1.66l3.79-5.43c.23-.33.53-.51.86-.53.3 0 .62.13.86.42l6.09 7.21H5.97v-.01Zm12.03 0h-.45l-3.2-3.79 1.72-1.69c.11-.11.25-.16.4-.15.15 0 .28.08.38.2l3.23 3.96c-.3.86-1.11 1.48-2.07 1.48l-.01-.01Zm2.2-3.85-2.12-2.6c-.38-.46-.94-.75-1.53-.78-.6-.03-1.18.19-1.61.61l-1.63 1.61-2.73-3.23c-.56-.66-1.35-1.03-2.16-.98-.83.04-1.59.48-2.1 1.21l-2.55 3.66v-6.3c0-1.21.99-2.2 2.2-2.2H18c1.21 0 2.2.99 2.2 2.2v6.8Z" />
      <Path d="M17.08 7a1.451 1.451 0 0 0 0 2.9 1.451 1.451 0 0 0 0-2.9Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhotoOutlined
